// extracted by mini-css-extract-plugin
module.exports = {"nadpis":"kontakty_nadpis__GvSu_","mapa":"kontakty_mapa__3yLCp","info":"kontakty_info__1M5sn"};